export default __webpack_public_path__ + "static/media/HeatScale.56995567.svg";